import React from 'react';

import { useHistory } from 'react-router';

import { FEATURE_USAGE_TASKS } from '../../feature-usage-task/feature-usage-task-utils';
import { employeeReferralsRoute } from '../../web-routes';

type InputProps = {
  hasFiltersActive: boolean;
  hasJobs: boolean;
  hasEmployeePermissions: boolean;
  orgId?: number;
};

export const ApplicantDirectoryEmptyState = ({
  hasFiltersActive,
  hasJobs,
  orgId,
  hasEmployeePermissions,
}: InputProps) => {
  const history = useHistory();
  const handleAskForReferralsClick = () => {
    history.push(employeeReferralsRoute(orgId));
  };

  return (
    <div className="card u-margin-top-lg">
      <div className="card-body">
        {hasFiltersActive ? (
          <div className="typo-h6 u-textAlign-center">
            No applicants found matching your filters
          </div>
        ) : (
          <div className="typo-h6 u-textAlign-center">
            You currently have no applicants.{' '}
            {orgId && hasJobs && hasEmployeePermissions ? (
              <span role="presentation" onClick={handleAskForReferralsClick} className="typo-link">
                Ask for employee referrals to get started
              </span>
            ) : (
              <a
                href={FEATURE_USAGE_TASKS.find((task) => task.name === 'ADD_JOB')?.details}
                target="_blank"
                rel="noopener noreferrer"
                className="typo-link"
              >
                Add a job to get started
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
